import { JobsiteFilterKeyString } from 'InstitutionalManagement/types'

export const JOBSITE_FIELDS_INITIAL_VALUES: JobsiteFilterKeyString = {
  id: '',
  name: '',
  description: '',
  status: '',
}
